import React, { Component } from 'react'
import "../../css/UsuarioVisitante.css"
import MenuUsuario from './MenuUsuario';

import { Link, Navigate} from "react-router-dom";
import Cookies from 'js-cookie';
import Header from '../components/Header.js'
import Footer from '../components/Footer.js'
import CenteredWrapper from '../components/CenteredWrapper.js'
import { limpiarSessionStorage } from "../../utils/session";



export default class UsuarioVisitante extends Component {

    constructor(props){
        super(props);

        this.state={
            verInformacion:null,
            modalIsOpen:false,
            modalError:false,
			      disablebtn:false,
			      modalGTSI:false,
            verificarDatosExt:{
                pasaporte:"",
                fechaNac:"",
                terminos:""
            },
            verificarDatosEcu:{
                cedula:"",
                fechaEmision:"",
                terminos:""
            },
            errorsDatosEcu:{
            },
            errorsDatosExtran:{
            },
            getVerificarUsuario:{
                id:0,
                identificacion:"",
                nombres:"",
                apellidos:"",
                usuarios:[],
            },
            expresiones:{
                cedula:/^[\d]{10}$/,
            },
			modalMessage:{
                show:false,
                titulo:"",
                mensaje:"",
                imagen:""
            },
			
        };
        this.verInfoEcuatoriano=this.verInfoEcuatoriano.bind(this);
        this.verInfoExtranjero=this.verInfoExtranjero.bind(this);
        this.handlerVerificarDatos=this.handlerVerificarDatos.bind(this);
        this.abrirModal=this.abrirModal.bind(this);
        this.cerrarModal=this.cerrarModal.bind(this);

        this.abrirModalError=this.abrirModalError.bind(this);
        this.cerrarModalError=this.cerrarModalError.bind(this);

		
		
  //      this.setearCookie=this.setearCookie.bind(this);
		
		//this.disablebutton = this.disablebutton.bind(this);
		//this.enablebutton = this.enablebutton.bind(this);
		
		    this.abrirModalMessage=this.abrirModalMessage.bind(this);
        this.cerrarModalMessage=this.cerrarModalMessage.bind(this);
		
		    this.abrirModalInfoGTSI=this.abrirModalInfoGTSI.bind(this);
        this.cerrarModalInfoGTSI=this.cerrarModalInfoGTSI.bind(this);

        //this.getVerificarUsuarioExtranj=this.getVerificarUsuarioExtranj.bind(this);
        
    }

    componentDidMount() {
        this.callTagManager();
        limpiarSessionStorage();
    }

    callTagManager() {
        window.dataLayer.push({
            event: "pageview-Inicio",
        });
    }


    abrirModalInfoGTSI(){
        this.setState({modalGTSI:true});
        //console.log("abrir modal "+this.state.modalGTSI);
    }

    cerrarModalInfoGTSI(){
        this.setState({modalGTSI:false});
        //console.log("cerrar modal "+this.state.modalGTSI);
    }
	
	abrirModalMessage(){
        this.setState({
            modalMessage:{
                ...this.state.modalMessage,
                show:true
            }
        });
    }

    limpiarCookies()
    {
        

            Cookies.remove("nombres");
            Cookies.remove("apellidos");
            Cookies.remove("identificacion");
            Cookies.remove("token");
            Cookies.remove("rol");
            Cookies.remove("username");
            Cookies.remove("DatosPersonalesGIA.CAS");
            Cookies.remove("id");
            Cookies.remove("correoAlterno");
            Cookies.remove("Nombre");
        
        
    }

    cerrarModalMessage(){
        this.setState({
            modalMessage:{
                titulo:"",
                mensaje:"",
                imagen:"",
                show:false
            }
        });
        //console.log("cerrar modal "+this.state.modalMessage);
    }
	
	
    abrirModal(){
        this.setState({modalIsOpen:true});
        //console.log("abrir modal "+this.state.modalIsOpen);
    }

    cerrarModal(){
        this.setState({modalIsOpen:false});
        //console.log("cerrar modal "+this.state.modalIsOpen);
    }

    abrirModalError(){
        this.setState({modalError:true});
    }

    cerrarModalError(){
        this.setState({modalError:false})
    }
	
	abrirModalIdnFeInc(){
        this.setState({modalIdnFeInc:true});
    }

    cerrarModalIdnFeInc(){
        this.setState({modalIdnFeInc:false})
    }
	
	abrirModalUserExist(){
        this.setState({modalUserExist:true});
    }

    cerrarModalUserExist(){
        this.setState({modalUserExist:false})
    }

//esta funcion funciona XD
    verInfoEcuatoriano(){
        this.setState({verInformacion:true});
    }

    verInfoExtranjero(){
        this.setState({verInformacion:false});
    }

	disablebutton(){
		 this.setState({disablebtn:true});
		 //console.log(this.state.disablebtn)
	}
	enablebutton(){
		 this.setState({disablebtn:false});
	}
	
    handlerVerificarDatos=async(e)=>{
        await this.setState({
            verificarDatosExt:{
                ...this.state.verificarDatosExt,
                [e.target.name]:e.target.value,
                terminos:e.target.checked
            }
        })
        //console.log(this.state.verificarDatosExt);
        this.handlerOnBlurExt();
    }

    handlerVerificarDatosEcu=async(e)=>{
		//console.log(this.state.verificarDatosEcu);

        await this.setState({
            verificarDatosEcu:{
                ...this.state.verificarDatosEcu,
                [e.target.name]:e.target.value,
                terminos:e.target.checked
            }
        })
		
        //console.log("handler");
        this.handlerOnBlurEcu();
        //console.log(this.state.verificarDatosEcu);
    }


    handlerOnBlurEcu=async(e)=>{
        
        if(!this.state.expresiones.cedula.test(this.state.verificarDatosEcu.cedula)){
            await this.setState({errorsDatosEcu:{
                cedula: "Identificacion debe tener 10 dígitos",
            }})
        }else{
            this.setState({errorsDatosEcu:{}})
        }
        //console.log("blur");
        //console.log(this.state.errorsDatosEcu);*/
    }

    handlerOnBlurExt=async(e)=>{
        if(!this.state.expresiones.cedula.test(this.state.verificarDatosExt.pasaporte)){
            await this.setState({errorsDatosExtran:{
                pasaporte: "Identificacion debe tener 10 dígitos",
            }})
        }else{
            this.setState({errorsDatosExtran:{}})
        }
        //console.log("blur");
       // console.log(this.state.errorsDatosExtran);*/
    }

   


    render() {
        this.limpiarCookies();  
        return (    
            <div >
                <MenuUsuario/>
                <Header />
                <CenteredWrapper>
                    <div className="visitante-body">
                        <div className="row-visitante-title">
                            <div className="col-12 col-sm-10 col-xl-8 title_visitante">
                                <div>
                                    <p className="visitante-title"><b>Seleccione la opción que desee ejecutar:</b></p>
                                </div>
                            </div>
                        </div>

                        <div className="row-visitante-btns">
                            <div className="col-12 col-md-3 visistante-div-registrarse" align="center"  >
                                <div className="" >    
                                    <Link to="/registro" onClick={()=>{window.dataLayer.push({event: "pageview-registro"})}}>                                
                                        <button className="visitante-btn-registrarse" >                                            
                                            <div className="col-sm-12" >
                                                <span >Crear<br></br>Cuenta</span>
                                            </div>                                            
                                        </button>     
                                    </Link>                               
                                </div>                            
                            </div>

                            <div className="col-12 col-md-3 visistante-div-changepass" align="center">
                                <div className="" >
                                    <Link to="/cambiarcontrasenia" onClick={() => { window.dataLayer.push({ event: "pageview-cambiarcontrasenia" }) }}>
                                    {/* <Link to="/cambiarcontraseniaredirect" onClick={() => { window.dataLayer.push({ event: "pageview-cambiarcontrasenia" }) }}> */}
                                        <button className="visitante-btn-changepass"  >
                                            <div className="col-sm-12" >
                                                <span >Cambiar<br></br>Contraseña</span>
                                            </div>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-12 col-md-3 visistante-div-resetpass" align="center">
                                <div className="" >
                                    <Link to="/olvidoContrasenia" onClick={() => { window.dataLayer.push({ event: "pageview-olvidocontrasena" }) }}>
                                    {/* <Link to="/login" onClick={() => { window.dataLayer.push({ event: "pageview-olvidocontrasena" }) }}> */}
                                        <button className="visitante-btn-resetpass"   >
                                            <div className="col-sm-12" >
                                                <span >¿Olvidó su contraseña?</span>
                                            </div>
                                        </button>
                                    </Link>
                                </div>                                
                            </div>
                            {/*<div className="col-12 col-md-3 visistante-div-firma" align="center">
                              <div className="" >
                                <Link to="/crearFirma" onClick={() => { window.dataLayer.push({ event: "pageview-crearFirma" }) }}>
                                  <button className="visitante-btn-firma">
                                    <div className="col-sm-12" >
                                      <span >Firma de Usuario</span>
                                    </div>
                                  </button>
                                </Link>
                              </div>
                            </div>
                            */}
                        </div>
                    </div>
                </CenteredWrapper>
                <Footer />
            </div>
            )
        
    }
}
